import { Controller } from '@hotwired/stimulus';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static targets = [
        'specialismContainer',
        'keywordsContainer',
        'specialismArrow',
    ];

    connect() {
        $(this.specialismArrowTarget).on('click', ()=> {
            $(this.specialismArrowTarget).hasClass('arrow-rotate')
                ? $(this.specialismArrowTarget).removeClass('arrow-rotate')
                : $(this.specialismArrowTarget).addClass('arrow-rotate');

            $(this.keywordsContainerTarget).toggle('collapse')
        });

        const checkbox = this.specialismContainerTarget.querySelector('input[type="checkbox"]');

        checkbox.addEventListener('change', () => {
            if (checkbox.checked && this.keywordsContainerTarget && this.keywordsContainerTarget.style.display === 'none'
            ) {
                this.specialismArrowTarget.click();
            }
        });
    }
}
